import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-body px-1" }

import { ref, watchEffect, shallowRef, onMounted } from 'vue';
import { typeSource } from "@/global-helper/handler";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import { useRoute } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.js";

// Variables

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const id = ref(route.params.id);

const data = ref<any>([]);
const type_source = ref('');
const is_loading = ref(false);
const component_form = shallowRef<any>(null);

// Function
function getData() {
  is_loading.value = true;

  ApiService.get(`/streams/detail/${id.value}`)
  .then((res) => {
    data.value = res.data;
    type_source.value = typeSource(data.value.source);
  })
  .catch((error) => {
    Swal.fire({
      title: "Gagal!",
      text: `${
        error.message
          ? error.message
          : "Terjadi kesalahan"
      }`,
      icon: "error",
      confirmButtonText: "Ok",
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-light-primary",
      },
    });
  })
  .finally(() => {
    is_loading.value = false;
  });
}

// Life Hook
watchEffect(async () => {
  if (data.value.source) {
    try {
      const component = (await import(`../berita/page-component/detail_${type_source.value}.vue`)).default;
      component_form.value = component;
    } catch (error) {
      component_form.value = null;
    }
  } else {
    component_form.value = null;
  }
});

onMounted(() => {
  setCurrentPageBreadcrumbs("Detail Berita", ["Berita"]);
  getData();
});

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        (_unref(component_form))
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component_form)), {
              key: 0,
              data: data.value
            }, null, 8, ["data"]))
          : _createCommentVNode("", true)
      ], 512), [
        [_directive_loading, is_loading.value]
      ])
    ])
  ]))
}
}

})